export const css = {
    root: 'GJpTy1KR',
    title: '_2ZkCJQQT',
    header: '_2aAbI9JV',
    checkBox: '_3jomFIBv',
    ' _key': 'explore-view/where-you-left-off'
};
export default css;
